module.exports = __webpack_public_path__ + "h5/img/douyin_1.5b8feec4.png";